import { useState } from 'react';
import api from '../api';

export default function ForcePasswordChange() {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) { setError('Пароль должен быть не короче 8 символов'); return; }
    if (newPassword !== newPassword2) { setError('Пароли не совпадают'); return; }
    setLoading(true);
    try {
      await api.patch('/users/me/password', { old_password: oldPassword, new_password: newPassword });
      window.location.href = (process.env.PUBLIC_URL || '') + '/';
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка смены пароля');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-form card" onSubmit={submit}>
        <div className="login-logo">GRAFFITI</div>
        <h2>Нужно сменить пароль перед началом работы</h2>
        {error && <div className="error-msg">{error}</div>}
        <div className="form-group">
          <label>Текущий пароль</label>
          <input type="password" value={oldPassword} onChange={e => setOldPassword(e.target.value)} required autoFocus />
        </div>
        <div className="form-group">
          <label>Новый пароль</label>
          <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required minLength={8} />
        </div>
        <div className="form-group">
          <label>Повторите новый пароль</label>
          <input type="password" value={newPassword2} onChange={e => setNewPassword2(e.target.value)} required minLength={8} />
        </div>
        <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
          {loading ? 'Сохраняем...' : 'Сменить пароль и продолжить'}
        </button>
      </form>
    </div>
  );
}
